(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  $(document).ready(() => {
    $('#kck-footer-phone').click(() => {
      window.open('tel:60362755500');
    });
  });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  $( document ).ready(function() {
    // handle qikify menu
    const tmenu_button = $('.tmenu_item.tmenu_item--root.tmenu_item_level_0.tmenu_item_submenu_type_mega.tmenu_item_submenu_mega_position_fullwidth.tmenu_item_has_child a')
    tmenu_button.on('click mouseover mouseleave',function() {
      $(this).siblings('ul').find('.tmenu-watermark.tmenu_item_link').remove();
    })

    // handle request quote
    if (window.location.href.indexOf("request-quote") > -1) {
      document.body.classList.add('quote-page-loading');
      $('#txtFirstName').attr('placeholder','First Name');
      $('#txtLastName').attr('placeholder','Last Name');
      $('#txtEmail').attr('placeholder','Email');
      $('#txtPhone').attr('placeholder','Phone Number');
      $('#txtRemarks').attr('placeholder','Remarks');

      $( ".quick-quote-header" ).replaceWith( "<div class='quick-quote-header' id='kck-custom-request-quote-header' style=''><h2 style='margin:0; padding-bottom:5rem;'>Request Quote</h2><a href='/' style='all:unset;cursor:pointer;text-decoration:underline;color:#111;'>CONTINUE SHOPPING</a></div>" );

      $('table tr th:first-child').text('Product ').attr('style', 'text-align: start !important;cursor:pointer;');

      $('#quick-quote-wrapper')
        .contents()
        .filter(function() {
          return this.nodeType == 3;
          }
        )
        .remove();

      const quoteFormWatcher = setInterval(function() {

      const quoteForm =
        document.querySelector('#pnl-request-quote');

      if (
        quoteForm &&
        !quoteForm.classList.contains('ng-hide')
      ) {

        document.body.classList.remove(
          'quote-page-loading'
        );

        clearInterval(quoteFormWatcher);
        clearTimeout(quoteLoadingFallback);
      }

    }, 100);


    const quoteLoadingFallback = setTimeout(function() {

      document.body.classList.remove(
        'quote-page-loading'
      );

      clearInterval(quoteFormWatcher);

    }, 4000);

      // ==========================================
      // QUICK QUOTE GOOGLE ADDRESS 2 FIX
      // ==========================================

      const googlePlaceWatcher = setInterval(function() {

        if (
          window.google &&
          google.maps &&
          google.maps.places &&
          google.maps.places.Autocomplete
        ) {

          clearInterval(googlePlaceWatcher);

          const autocompletePrototype =
            google.maps.places.Autocomplete.prototype;

          const originalGetPlace =
            google.maps.places.Autocomplete.prototype.getPlace;


          // Do not patch more than once
          if (!autocompletePrototype._address2Patched) {

            autocompletePrototype.getPlace = function() {

              const place = originalGetPlace.apply(this, arguments);

              setTimeout(function() {
                fillAddress2FromGoogle(place);
              }, 300);

              return place;
            };


            autocompletePrototype._address2Patched = true;

          }

        }

      }, 200);

      function fillAddress2FromGoogle(place) {

        const address2Input =
          document.querySelector(
            '[id^="customAddress2Field_"]'
          );

        if (
          !place ||
          !place.address_components ||
          !address2Input
        ) {
          return;
        }

        const address2Parts = [];

        place.address_components.forEach(function(component) {

          const types = component.types || [];

          const excludedTypes = [
            'street_number',
            'route',
            'locality',
            'postal_town',
            'administrative_area_level_1',
            'administrative_area_level_2',
            'country',
            'postal_code'
          ];

          const shouldExclude = types.some(function(type) {
            return excludedTypes.includes(type);
          });

          if (shouldExclude) {
            return;
          }

          if (
            component.long_name &&
            !address2Parts.includes(component.long_name)
          ) {
            address2Parts.push(component.long_name);
          }

        });

        if (address2Parts.length === 0) {
          return;
        }

        const address2Value =
          address2Parts.join(', ');

        console.log(
          'Address 2:',
          address2Value
        );

        address2Input.value =
          address2Value;

        address2Input.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        address2Input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );

      }    

      var intervalId = null;
      const replaceQuoteContainer = function() {
        const quoteNumber = $('#quote-number').html();
        if(quoteNumber.length > 0){

          $('#pnl-thank-you h2').replaceWith(`<div id="thank-you-wrapper">
          <div>Thank you for submitting your request for a quote.</div>
          <div>Your quote request number is:</div>
          <div>${quoteNumber}</div>
          </div>`);
          $('body').addClass('quote-submitted');

          const continueShopping = $('#kck-custom-request-quote-header a');
          $('<div id="continue-shopping-wrapper"></div>')
          .insertAfter('#pnl-thank-you')
          .append(continueShopping);

          $('#quick-quote-wrapper').attr('style','padding-top:1em;background-color: #f5f5f5;min-height: 100vh;display: flex;justify-content: center;max-width:unset !important;');
          clearInterval(intervalId);
        }
      }

      $('#submit-quote').on('click', function(){
        intervalId = setInterval(replaceQuoteContainer, 1000);
      })

      // Target View `Your Quote`
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      const currentPage = urlParams.get('page')
      if(currentPage === 'accept'){

        var textareaPlaceholder = 'Add your comment here.';
        $('#quote-comment-box').find('h2').remove();
        $('#quote-txt-comment').attr('placeholder',textareaPlaceholder);

        var placeholderInterval = null;
        var getPlaceholderValues = function(){
          var placeholderValues = $('#quote-txt-comment').attr('placeholder');
          if(placeholderValues !== textareaPlaceholder){
            $('#quote-txt-comment').attr('placeholder', textareaPlaceholder );
            clearInterval(placeholderInterval);
          }
        };

        placeholderInterval = setInterval(getPlaceholderValues, 1000);


        $('#quote-bottom-buttons').attr('style','');
        $('#quote-comments').attr('style','');

        var wmOne = $(document).find('a[title="Houston Web Design | Shopify Apps"]').remove();
        var vmTwo = $(document).find('a[title="Request Quote Shopify App"]').remove();

        $('#quote-subtotal').css({display: 'none'});
        $('#quote-tax').css({display: 'none'});
        $('#quote-total').css({display: 'none'});

        $('#quote-txt-comment').css({ 
          minHeight: '120px',
          padding: '1.5rem',
          border: 'none',
          boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
          borderRadius: '4px',
          resize: 'none',
          width: '100%',
          maxWidth: '769px',
        });


        $('span.item-title').attr('style','color:#111 !important;font-size:1.8rem;');
        $('span.item-title').after('<br/>');
        
        $(document).find('.quote-table').css({
          borderBottom: '1px solid #f5f5f5',
          paddingBottom: '2rem'
        });


        $(document).on('click', '#customAcceptButton', function(e){
          e.preventDefault();
          $(document).find('#accept-quote').click();
        })

        var taxPriceContainer = $('#quote-tax').text().trim().replace('Tax:', '');
        var totalPriceContainer = $('#quote-total').text().trim().replace('Total:', '');
        var subtotalContainer = $('#quote-subtotal').text().trim().replace('Subtotal: ', '');

        var attachedButton = $(document).find('#accept-quote').detach();
        var $customAcceptButtonContainer = $(`<div class='custom-button-container'><div class="customPriceContainer"><div>Subtotal</div><div>${subtotalContainer}</div></div><div class="customPriceContainer"><div>Tax</div><div>${taxPriceContainer}</div></div><div class="customPriceContainer"><div>Total</div><div>${totalPriceContainer}</div></div></div>`);
        $customAcceptButtonContainer.append(attachedButton);

        var commentBoxChildOne = $(document).find('#quote-comments').detach();
        var $hr = "<hr style='margin:1rem 0 3rem 1rem;background-color:rgba(0,0,0,0.1);'/>";
        var commentBoxChildTwo = $(document).find('#quote-txt-comment').detach();
        var commentBoxChildThree = $(document).find('#send-comment').detach();
        var $customCommentContainer = $('<div style="display:flex;flex-direction:column;gap:.5em;"><h2 id="comments-data" style="margin:0;">Comment on this quote</h2></div>');
        $customCommentContainer.append(commentBoxChildOne, $hr, commentBoxChildTwo, commentBoxChildThree );

        $(document).find('#quote-comment-box br').remove();
        $(document).find('#quote-comment-box').css({ marginTop: '2em', position:'relative', justifyContent: 'space-between', display: 'flex'}).append($customCommentContainer, $customAcceptButtonContainer);
        $(document).find('#accept-quote').css({fontSize : '1.2rem'});
        var isQuoteAccepted = $(document).find('.qq-status-alert.qq-status-alert-accepted');
        if(isQuoteAccepted.length > 0){
          $('#quote-comments').remove();
          $('#quote-comment-box > *:first-child > *').remove();

        }
      }
      
    }


    // Make all the columns the same height - Calculate the maximum height
    const columns = document.querySelectorAll('.kuckreja-product-card-header');
    let maxHeight = 0;
    columns.forEach(column => {
      const height = column.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Set the maximum height for all columns
    columns.forEach(column => {
      column.style.height = `${maxHeight}px`;
    });


  });

  } catch(e) { console.error(e); }
})();
})();
